<template>
    <div class="dashboard container">
        <NavBar/>
        <b-card no-body class="mb-1 mt-5 images">
            <b-card-header header-tag="header" class="p-1">
                Εικόνες
            </b-card-header>
            <b-card-body v-if="images">
                Συνιστώμενο μέγεθος για ορθή χρήση: 1400*750
                <hr>

                <div class="row border-bottom p-2">
                    <div class="col-md-6">
                        <img :src="images.header" alt="img" width="50%"/>
                    </div>
                    <div class="col-md-6">
                        <form>
                            <div class="fields">
                                <label>Αλλαγή εικόνας:</label><br/>
                                <input type="file" ref="file1" name="file1" @change="onSelect(1)"/>
                            </div>
                        </form>
                    </div>
                </div>
                <h5>{{message}}</h5>
                <b-form-group>
                    <b-button variant="primary" @click="updateImageData" :disabled="!imageChanged">Αποθήκευση αλλαγών</b-button>
                </b-form-group>

            </b-card-body>
        </b-card>

        <b-card v-if="data.el && data.en">
            <b-card-title>Επεξεργασία</b-card-title>
            <b-tabs>
                <b-form @input="hasChanged = true">
                    <b-tab title="Ελληνικά">
                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1">
                                Κείμενο
                            </b-card-header>
                            <b-card-body>
                                <b-form-group>
                                    <b-form-input v-model="data.el.title1"></b-form-input>
                                </b-form-group>
                                <b-form-group>
                                    <b-form-textarea rows="4" v-model="data.el.paragraph1"></b-form-textarea>
                                </b-form-group>

                                ----

                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.el.paragraph2"></b-form-textarea>
                                </b-form-group>
                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.el.paragraph3"></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.el.paragraph4"></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <b-button variant="primary" @click="updateHomeData" :disabled="!hasChanged">Αποθήκευση αλλαγών</b-button>
                                </b-form-group>
                            </b-card-body>
                        </b-card>
                    </b-tab>

                    <b-tab title="Αγγλικά">
                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1">
                                Text
                            </b-card-header>
                            <b-card-body>
                                <b-form-group>
                                    <b-form-input v-model="data.en.title1" :placeholder="data.el.title1"></b-form-input>
                                </b-form-group>
                                <b-form-group>
                                    <b-form-textarea rows="4" v-model="data.en.paragraph1" :placeholder="data.el.paragraph1"></b-form-textarea>
                                </b-form-group>
                                ----

                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.en.paragraph2" :placeholder="data.el.paragraph2"></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.en.paragraph3" :placeholder="data.el.paragraph3"></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <b-form-textarea rows="6" v-model="data.en.paragraph4" :placeholder="data.el.paragraph4"></b-form-textarea>
                                </b-form-group>

                                <b-form-group>
                                    <b-button variant="primary" @click="updateHomeData" :disabled="!hasChanged">Αποθήκευση αλλαγών</b-button>
                                </b-form-group>
                            </b-card-body>
                        </b-card>
                    </b-tab>
                </b-form>
            </b-tabs>
        </b-card>

    </div>
</template>
<script>
    import NavBar from '../components/NavBar'
    import axios from 'axios'

    export default{
        components: {NavBar},

        data(){
            return{
                hasChanged: false,
                imageData: {
                    one: null,
                },
                images:{},
                data: {},
                file:"",
                message:"",
                uploadedImage: null,
                imageChanged: false
            }
        },

        created(){
            this.getData();
        },

        methods:{
            getData(){
                axios.get(this.apiUrl + '/pages/4').then(result=>{
                    this.data = JSON.parse(result.data.data);
                    this.images = JSON.parse(result.data.images);
                })
            },

            updateHomeData(){
                axios.defaults.headers.common['x-access-token'] = localStorage.getItem('token');
                axios.put(this.apiUrl + '/pages/4', {type: 'dataOnly', data: this.data}).then( () =>{
                    this.hasChanged= false;
                })
            },
            updateImageData(){
                axios.defaults.headers.common['x-access-token'] = localStorage.getItem('token');
                axios.put(this.apiUrl + '/pages/4', {type:'imageOnly', images: this.images}).then( () =>{
                    this.imageChanged= false;
                    this.message = null
                })
            },
            onSelect(num){
                const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
                const file = this.$refs['file'+ num].files[0];
                this.file = file;
                if(!allowedTypes.includes(file.type)){
                    this.message = "Λάθος αρχείο. Επισυνάψτε jpg/jpeg εικόνα!!!"
                }
                if(file.size>500000){
                    this.message = 'Πολύ μεγάλο αρχείο. Το μέγιστο μέγεθος είναι 500kb'
                }
                this.onSubmit(num);
            },

            async onSubmit(num){
                const formData = new FormData();
                formData.append('image',this.file);
                try{
                    await axios.post(this.apiUrl + '/users/upload-image',formData).then(result=>{
                        if(num === 1){
                            this.images.header = result.data.imageUrl;
                        }
                        this.imageChanged=true
                    });

                    this.message = 'Η φωτογραφία ανέβηκε επιτυχώς. Μην ξεχάσετε να την δημοσιεύσετε πατώντας "αποθήκευση"!'
                }
                catch(err){
                    this.message = err.response.data.error
                }
            }
        }
    }

</script>